<template>
  <div
    v-if="
      !isAuthenticated ||
      (processus &&
        processusDRH &&
        processusAdmin &&
        processusConsultation &&
        processusConsultationPIECE)
    "
  >
    <v-navigation-drawer
      dark
      clipped
      :mini-variant="isMini"
      :mini-variant-width="miniMenuWidth"
      v-model="displayMenuModel"
      app
      :temporary="isSmartphoneMenu"
      mobile-breakpoint="960"
      width="300"
    >
      <v-card color="#32a68c" v-if="isSmartphoneMenu">
        <v-list-item v-if="!isAuthenticated" @click="login">
          <v-list-item-action>
            <v-icon>login</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Connexion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <v-list>
        <div v-for="link in links" :key="link.name">
          <!-- sous-sous-groupes -->
          <v-list-group
            v-if="
              getLinkVisibility(link.meta, false) && link.section && !link.tuile
            "
            vv-model="activeFormComplementaire"
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ link.title }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <div v-if="link.definition">
              <div v-for="sousLink in link.definition" :key="sousLink.id">
                <v-list-item
                  :to="$router.options.routes[sousLink.id].path"
                  v-if="
                    getLinkVisibility(
                      $router.options.routes[sousLink.id].meta,
                      true
                    )
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $router.options.routes[sousLink.id].title
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon>{{
                      $router.options.routes[sousLink.id].icon
                    }}</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </div>

            <div v-for="section in link.section" :key="section.name">
              <v-list-group sub-group>
                <template v-slot:activator>
                  <v-list-item-title>{{ section.name }}</v-list-item-title>
                </template>

                <div v-for="sousLink in section.links" :key="sousLink.id">
                  <v-list-item
                    :to="$router.options.routes[sousLink.id].path"
                    v-if="
                      getLinkVisibility(
                        $router.options.routes[sousLink.id].meta,
                        true
                      )
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $router.options.routes[sousLink.id].title
                      }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon>{{
                        $router.options.routes[sousLink.id].icon
                      }}</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </div>
              </v-list-group>
            </div>
          </v-list-group>

          <!-- Sous-groupes -->
          <v-list-group
            v-else-if="
              getLinkVisibility(link.meta, false) &&
              link.definition &&
              !link.tuile
            "
            vv-model="activeFormComplementaire"
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ link.title }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <div v-for="sousLink in link.definition" :key="sousLink.id">
              <v-list-item
                :to="$router.options.routes[sousLink.id].path"
                v-if="
                  getLinkVisibility(
                    $router.options.routes[sousLink.id].meta,
                    true
                  )
                "
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    $router.options.routes[sousLink.id].title
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>{{
                    $router.options.routes[sousLink.id].icon
                  }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list-group>

          <!-- Groupes -->
          <v-list-item
            :to="link.path"
            v-else-if="getLinkVisibility(link.meta, false) && !link.tuile"
          >
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <div v-if="isAuthenticated">
          <!-- PERSONNEL-->
          <div v-if="user.roles.includes('PERSONNEL')">
            <div v-for="key in processusKeys" :key="key">
              <div v-if="processus[key].length > 0">
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-item-action>
                      <v-icon>roundabout_left</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ key }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <div v-for="p in processus[key]" :key="p.id">
                    <v-list-item :to="p.route">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ p.name }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>{{ p.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </v-list-group>
              </div>
              <div v-else>
                <div>
                  <v-list-item :to="processus[key][0].route">
                    <v-list-item-action>
                      <v-icon>{{ processus[key][0].icon }}</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{
                        processus[key][0].name
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </div>
          </div>
          <!-- PERSONNEL FIN-->
          <div
            v-if="
              user.roles.includes('CONSULTATION') ||
              user.roles.includes('CONSULTATION_PIECE')
            "
          >
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-action>
                  <v-icon>visibility</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title> Consultation </v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="user.roles.includes('CONSULTATION')">
                <div
                  v-for="keyConsultation in processusKeysConsultation"
                  :key="keyConsultation"
                >
                  <!-- <v-list-group sub-group>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ keyConsultation }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template> -->

                  <div
                    v-for="p in processusConsultation[keyConsultation]"
                    :key="p.id"
                  >
                    <v-list-item :to="p.route">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ p.name }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>{{ p.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                  <!-- </v-list-group> -->
                </div>
              </div>
              <div v-if="user.roles.includes('CONSULTATION_PIECE')">
                <div
                  v-for="keyConsultation in processusKeysConsultationPIECE"
                  :key="keyConsultation"
                >
                  <!-- <v-list-group sub-group>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ keyConsultation }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template> -->

                  <div
                    v-for="p in processusConsultationPIECE[keyConsultation]"
                    :key="p.id"
                  >
                    <v-list-item :to="p.route">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ p.name }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>{{ p.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                  <!-- </v-list-group> -->
                </div>
              </div>
            </v-list-group>
          </div>

          <!-- <div v-if="user.roles.includes('CONSULTATION_PIECE')">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-action>
                  <v-icon>visibility</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title> Consultation </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-group>
          </div> -->

          <hr />
          <div
            v-if="user.roles.includes('GRH') || user.roles.includes('ADMIN')"
          >
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-action>
                  <v-icon>mdi-google</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title> DRH </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item to="/accueilDRH">
                <v-list-item-action>
                  <v-icon>home</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title> Accueil </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <div v-for="keyDRH in processusKeysDRH" :key="keyDRH">
                <v-list-group sub-group>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ keyDRH }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <div v-for="p in processusDRH[keyDRH]" :key="p.id">
                    <v-list-item :to="p.route">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ p.name }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon>{{ p.icon }}</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </v-list-group>
              </div>
            </v-list-group>
            <!-- <div>
            <div>
              <v-list-item :to="processusDRH[keyDRH][0].route">
                <v-list-item-action>
                  <v-icon>{{ processusDRH[keyDRH][0].icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{
                    processusDRH[keyDRH][0].name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div> -->
          </div>
          <hr />
          <div v-if="user.roles.includes('ADMIN')">
            <div>
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-action>
                    <v-icon>mdi-account-circle</v-icon>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title> Administration </v-list-item-title>
                  </v-list-item-content>
                </template>

                <div v-for="keyAdmin in processusKeysAdmin" :key="keyAdmin">
                  <v-list-group sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ keyAdmin }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <div v-for="p in processusAdmin[keyAdmin]" :key="p.id">
                      <v-list-item :to="p.route">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ p.name }}
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-icon>{{ p.icon }}</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                  </v-list-group>
                </div>
              </v-list-group>
            </div>
            <!-- <div>
            <div>
              <v-list-item :to="processusAdmin[keyAdmin][0].route">
                <v-list-item-action>
                  <v-icon>{{ processusAdmin[keyAdmin][0].icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{
                    processusAdmin[keyAdmin][0].name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div> -->
          </div>
        </div>
      </v-list>

      <!-- <v-card
        v-show="this.displayedArrow()"
        class="hidden-sm-and-down moving-arrow"
        :style="arrowStyle"
      ></v-card> -->

      <template v-slot:append>
        <div class="pa-2 text-center">
          <a href="https://www.univ-lille.fr" title="Université de Lille">
            <img :src="getLogoUrl(logo)" />
          </a>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApiProcessusRepository from "@/repositories/ApiProcessusRepository";

export default {
  name: "BaseMenu",
  props: { displayMenu: Boolean, isSmartphoneMenu: Boolean, isMini: Boolean },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      // URL de connexion
      loginUrl:
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOGIN,
      activeLinkIndex: 0,
      activeSousLinkIndex: 0,
      activeLink: null,
      linkHeight: 48,
      logo: "logo.png",
      activeFormComplementaire: false,
      processus: null,
      processusDRH: null,
      processusAdmin: null,
      processusConsultation: null,
      processusConsultationPIECE: null,
      processusKeys: null,
      processusKeysDRH: null,
      processusKeyAdmin: null,
      processusKeysConsultation: null,
      processusKeysConsultationPIECE: null,
    };
  },
  computed: {
    ...mapState(["user", "isAuthenticated"]),

    displayMenuModel: {
      get() {
        return this.displayMenu;
      },
      set(value) {
        this.$emit("update:displayMenu", value);
      },
    },
    miniMenuWidth() {
      if (this.isSmartphoneMenu) {
        return 63;
      }
      return 55;
    },

    arrowStyle() {
      var arrowMovePx = this.linkHeight * this.findActiveLinkPosition();
      return {
        transform: `translate3d(0px, ${arrowMovePx}px, 0px)`,
      };
    },

    links() {
      return this.$router.options.routes;
    },
  },
  async mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true,
    });

    if (this.$store.state.user != null) {
      this.processus = await ApiProcessusRepository.getAllPersonnelinMap();
      this.processusKeys = Object.keys(this.processus);
      this.processusDRH = await ApiProcessusRepository.getAllDRHinMap();
      this.processusKeysDRH = Object.keys(this.processusDRH);
      this.processusAdmin = await ApiProcessusRepository.getAllAdmininMap();
      this.processusKeysAdmin = Object.keys(this.processusAdmin);
      this.processusConsultation =
        await ApiProcessusRepository.getAllConsultationinMap();
      this.processusConsultationPIECE =
        await ApiProcessusRepository.getAllConsultationPIECEinMap();
      this.processusKeysConsultation = Object.keys(this.processusConsultation);
      this.processusKeysConsultationPIECE = Object.keys(
        this.processusConsultationPIECE
      );
      console.log(this.processusDRH[this.processusKeysDRH[0]]);
    }

    if (this.isMini) {
      this.logo = "logo-extrasmall.png";
    }
  },
  methods: {
    // action login => envoie vers l'identification CAS via le backend de l'application
    login() {
      window.location = this.loginUrl;
    },
    displayedArrow() {
      if (this.activeLink) return true;
    },

    findActiveLinkPosition() {
      var position = -1;

      this.$router.options.routes.every((link, index) => {
        if (index <= this.activeLinkIndex) {
          if (this.getLinkVisibility(link.meta)) position++;
          if (this.activeFormComplementaire && link.definition) {
            link.definition.forEach((sousLink, indexSousLink) => {
              if (this.activeLink.sousMenu) {
                if (indexSousLink + index + 1 <= this.activeLinkIndex - 1) {
                  //automatiser le +1 suivant les éléments du menu après les actives
                  if (this.getLinkVisibility(sousLink.meta)) {
                    position++;
                  }
                }
              } else {
                if (indexSousLink <= this.activeLinkIndex) {
                  if (this.getLinkVisibility(sousLink.meta)) {
                    position++;
                  }
                }
              }
            });
            if (this.activeLink.sousMenu) {
              return false;
            }
          } else if (this.activeLink.sousMenu && link.definition) {
            position--; //multiplié par le nombre de lien disponible après //à automatiser
            // position--;
          }
          return true;
        }
      });
      // if(this.activeFormComplementaire)
      // {
      //   position += 4;
      // }
      return position;
    },
    findActiveLink() {
      this.$router.options.routes.forEach((link, index) => {
        if (link.name == this.$route.name) {
          this.activeLinkIndex = index;
          this.activeLink = link;
          if (this.activeFormComplementaire && link.definition) {
            link.definition.forEach((sousLink, indexSousLink) => {
              if (sousLink.name == this.$route.name) {
                this.activeSousLinkIndex = indexSousLink;
                // this.activeLink = sousLink;
              }
            });
          }
        }
      });
    },
    getLogoUrl(logoName) {
      return require("@/assets/" + logoName);
    },
    getLinkVisibility(linkMetas, sousMenu) {
      if (!linkMetas.menu && !linkMetas.sousMenu) {
        return false;
      } else {
        var linkVisibility = false;
        // aucune précison sur l'autorisation d'accès à cette route
        if (linkMetas.access === undefined) {
          linkVisibility = true;
        }
        // route publique (toujours autorisée)
        else if (linkMetas.access.type === "public") {
          linkVisibility = true;
        }
        // route accessible uniquement aux utilisateurs non-authentifiés
        else if (linkMetas.access.type === "anonymous") {
          // si l'utilisateur a accès et n'est pas authentifié
          if (!this.isAuthenticated) {
            linkVisibility = true;
          }
        }
        // route accessible uniquement aux utilisateurs authentifiés
        else if (linkMetas.access.type === "authenticated") {
          // si l'utilisateur est authentifié
          if (this.isAuthenticated) {
            linkVisibility = true;
            // pour chaque rôle de l'utilisateur,
            // on teste sa présence dans la liste des rôles autorisés à accéder à cette route
            if (Array.isArray(linkMetas.access.roles)) {
              linkVisibility = false;
              if (Array.isArray(this.user.roles)) {
                this.user.roles.forEach((userRole) => {
                  if (linkMetas.access.roles.indexOf(userRole) > -1) {
                    linkVisibility = true;
                  }
                });
              }
            }
          }
        }
        if (!sousMenu && linkMetas.sousMenu) {
          //Pour empêcher l'affichage de la route en double si elle est contenu dans un sous-menu.
          linkVisibility = false;
        }
        return linkVisibility;
      }
    },
  },
};
</script>

<style scoped>
.v-application a.v-list-item--active {
  color: #ffffff;
}
.v-list-item__title {
  font-size: 0.9em;
}

div.moving-arrow.v-card {
  box-shadow: none;
  background-color: transparent;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  display: inline-block;
  position: absolute;
  left: 284px;
  top: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1);
  z-index: 1;
}

.v-application.theme--light div.moving-arrow.v-card {
  border-right: 17px solid #ededed !important;
}

.v-application.theme--dark div.moving-arrow.v-card {
  border-right: 17px solid #121212 !important;
}
</style>
